import { MouseEventFlags } from "../EventHandler";
export class Render {
    constructor() {
        this._listensFor = MouseEventFlags.None;
        this._eventHandler = null;
        this.contourIndex = -1;
        this.pointIndex = -1;
        this.updateNeeded = true;
    }
    get listensFor() { return this._listensFor; }
    triggerEvent(event) {
        if (this._eventHandler)
            this._eventHandler(event);
    }
    listenFor(eventFlags, handler) {
        this._eventHandler = handler;
        this._listensFor = eventFlags;
    }
}
export class StaticRender extends Render {
}
export class VectorRender extends StaticRender {
    drawOnCanvas(ctx, map) {
        ctx.save();
        this.setupRender(ctx, map);
        this.renderObject(ctx, map);
        ctx.restore();
    }
    ;
}
export class DynamicRender extends Render {
    constructor({ node, update, redraw, onRender }) {
        super();
        this.node = node;
        this.update = update;
        this.onRender = onRender;
        this.redraw = redraw;
    }
    contains(position) {
        return false;
    }
}
